import React from 'react';

const Services = () => {
    return (
        <div className="pt-24 pb-16 container mx-auto px-4">
            <h1 className="text-3xl font-bold mb-8">Nuestros Servicios</h1>
            <p>Ofrecemos una amplia gama de servicios inmobiliarios.</p>
        </div>
    );
};

export default Services;
